const ActionableState = {
    SKIP: 'skip',
    TOGGLE: 'toggle',
    TRUE: 'true',
    FALSE: 'false'
}

export default ActionableState;